import { combineReducers } from 'redux';

// Confirmation
import { confirmationReducer } from '../../Confirmation/ConfirmationReducers';
import { IConfirmationState } from '../../Confirmation/ConfirmationModel';

// Notification
import { notifications } from '../../Notifications/NotificationReducer';
import { INotificationState } from '../../Notifications/notificationModel';

// Errors
import { errors } from '../../Workspace/DataSources/Errors/ErrorsReducer';
import { IErrorsState } from '../../Workspace/DataSources/Errors/ErrorsModel';

// Dashboard
import {
    dashboard,
    dashboardConfig,
    areaConfigs,
} from '../../Workspace/Dashboard/DashboardReducer';

// Cases
import { caseReducer } from '../../Workspace/Case/CaseReducer';
import { ICaseState } from '../../../common/model/CaseModels';

// User
import { userReducer } from '../../User/UserReducer';
import { IUserState } from '../../../common/model/UserModels';

// Workspace
import { workspaceReducer } from '../../Workspace/WorkspaceReducer';
import { IWorkspaceState } from '../../../common/model/WorkspaceModels';

// AuditWrapper
import { auditReducer } from '../../Audit/AuditReducer';
import { IAuditState } from '../../../common/model/AuditModels';

// AuditWrapper
import { securityReducer } from '../../Workspace/Security/SecurityReducer';

// Root Reducer
const index = combineReducers({
    confirmation: confirmationReducer,
    notifications,
    errors,
    dashboard,
    dashboardConfig,
    areaConfigs,
    user: userReducer,
    workspace: workspaceReducer,
    cases: caseReducer,
    audit: auditReducer,
    security: securityReducer,
});

export interface IAppStore {
    confirmation?: IConfirmationState;
    notifications?: INotificationState;
    errors?: IErrorsState;
    user?: IUserState;
    workspace?: IWorkspaceState;
    cases?: ICaseState;
    activities?: IAuditState;
    security?: IWorkspaceState;
}

export default index;
